import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom' 
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const CarryingParentguardian = () => {
    useEffect(() => {
        document.title = 'Carrying of Parent/Guardian ID -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Admissions </li>
                 <li>Carrying of Parent/Guardian ID</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Carrying of Parent/Guardian ID </h1>
                    </div>
                </div>
                <div className="row">
                   <div className="col-lg-12">
                    <LazyLoad>
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/GuardianID.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/GuardianID.jpg" className="mx-auto d-block schoollib img-fluid" alt="TAFS" /></a> 
                    </LazyLoad> 
                     
                   </div>
 
            </div>
            </div>
        </div>
     </>
  )
}

export default CarryingParentguardian